export const CHANGE_SIGNUP_PAGE = 'CHANGE_SIGNUP_PAGE'

export function changeSignupPage(data) {
  return {
    type: CHANGE_SIGNUP_PAGE,
    data
  }
}
